import React from 'react'
import CustomSelect from '../../../../components/CustomSelect/CustomSelect'

/**
 * 🛠 Доп. начисления — кастомные правила ЗП (ручные доп. работы)
 * 📈 Авто-бонусы за объем операций (планы с возможностью отключения)
 */
export default function CustomRulesSection({
  settings,
  onChange,
  onAddRule,
  onUpdateRule,
  onRemoveRule,
  onConvertRule,
}) {
  // Фильтруем правила
  const manualRules = (settings.customRules || []).filter(r => !String(r.id || '').startsWith('system:'))
  const volumeRules = (settings.customRules || []).filter(r => String(r.id || '').startsWith('system:vol_bonus_'))

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      
      {/* ──────────────────────────────────────────────────────── */}
      {/* СЕКЦИЯ 1: Ручные начисления (Доп. работы) */}
      {/* ──────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        <div style={{ fontWeight: 700, fontSize: '15px', color: 'var(--text-primary)' }}>
          Ручные доп. начисления
        </div>
        <div style={{
          padding: '10px 14px', background: 'var(--surface-hover)', borderRadius: '10px',
          fontSize: '12.5px', color: 'var(--text-secondary)', lineHeight: '1.5',
        }}>
          Добавьте свои метрики оплаты: переупаковка, процент от оборота, премии за рейтинг и т.д.
          Сотрудники увидят их как «Доп. работы» и смогут самостоятельно фиксировать количество.
        </div>

        {manualRules.length === 0 ? (
          <div style={{
            padding: '20px', textAlign: 'center', borderRadius: '12px',
            border: '2px dashed var(--border-color)', color: 'var(--text-tertiary)',
            fontSize: '13px',
          }}>
            Нет ручных доп. начислений
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {manualRules.map((rule, index) => (
              <div
                key={rule.id}
                style={{
                  display: 'flex', gap: '10px', alignItems: 'flex-start',
                  background: 'var(--surface-hover)', padding: '14px 16px',
                  borderRadius: '12px', border: '1px solid var(--border-color)',
                }}
              >
                <div style={{
                  width: '26px', height: '26px', borderRadius: '8px',
                  background: 'var(--wb-primary)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '12px', fontWeight: 700, flexShrink: 0, marginTop: '22px',
                }}>
                  {index + 1}
                </div>

                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div className="input-group" style={{ flex: 2, marginBottom: 0, minWidth: '150px' }}>
                      <label>Название</label>
                      <input
                        className="input"
                        placeholder="Например: Переупаковка"
                        value={rule.name}
                        onChange={e => onUpdateRule(rule.id, 'name', e.target.value)}
                      />
                    </div>
                    <div className="input-group" style={{ flex: 1, marginBottom: 0, minWidth: '120px' }}>
                      <label>Тип</label>
                      <CustomSelect
                        value={rule.type}
                        onChange={val => onUpdateRule(rule.id, 'type', val)}
                        options={[
                          { value: 'per_item', label: 'За штуку / раз' },
                          { value: 'percent', label: 'Процент от суммы' },
                          { value: 'fixed', label: 'Фикс. доплата в смену' },
                        ]}
                      />
                    </div>
                    <div className="input-group" style={{ flex: 1, marginBottom: 0, minWidth: '100px' }}>
                      <label>Значение</label>
                      <div className="salary-config-input-wrapper">
                        <input
                          className="input"
                          type="number"
                          step="0.1"
                          value={rule.amount}
                          onChange={e => onUpdateRule(rule.id, 'amount', e.target.value === '' ? '' : Number(e.target.value))}
                        />
                        <span className="salary-config-unit">
                          {rule.type === 'percent' ? '%' : '₽'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignSelf: 'flex-end', flexShrink: 0 }}>
                  <button
                    type="button"
                    className="btn btn-ghost"
                    style={{
                      color: 'var(--info)', height: '32px', fontSize: '11px',
                      padding: '0 8px', borderRadius: '8px',
                      border: '1px solid color-mix(in srgb, var(--info) 25%, transparent)',
                      whiteSpace: 'nowrap',
                    }}
                    title="Конвертировать все операции этого типа в стандартный"
                    onClick={() => onConvertRule(rule)}
                  >
                    Перевести
                  </button>
                  <button
                    type="button"
                    className="btn btn-ghost"
                    style={{
                      color: 'var(--danger)', height: '32px', fontSize: '11px',
                      padding: '0 8px',
                    }}
                    onClick={() => onRemoveRule(rule.id)}
                  >
                    Удалить
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onAddRule('per_item')}
          style={{
            alignSelf: 'flex-start',
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '10px 18px', borderRadius: '10px',
            fontSize: '13px', fontWeight: 600,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Добавить ручное начисление
        </button>
      </div>

      {/* ──────────────────────────────────────────────────────── */}
      {/* СЕКЦИЯ 2: Автоматические бонусы за объем */}
      {/* ──────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', borderTop: '1px solid var(--border-color)', paddingTop: '20px' }}>
        <div style={{ fontWeight: 700, fontSize: '15px', color: 'var(--text-primary)' }}>
          Бонусы за объем операций (Планы)
        </div>
        <div style={{
          padding: '10px 14px', background: 'var(--surface-hover)', borderRadius: '10px',
          fontSize: '12.5px', color: 'var(--text-secondary)', lineHeight: '1.5',
        }}>
          Начисляйте премии сотрудникам автоматически при превышении порогов за расчетный период.
          Например, при приемке более 500 коробок выдать бонус 1000 ₽. Владелец может временно отключать бонусы чекбоксом «Вкл/Выкл».
        </div>

        {volumeRules.length === 0 ? (
          <div style={{
            padding: '20px', textAlign: 'center', borderRadius: '12px',
            border: '2px dashed var(--border-color)', color: 'var(--text-tertiary)',
            fontSize: '13px',
          }}>
            Нет бонусов за объем
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {volumeRules.map((rule, index) => (
              <div
                key={rule.id}
                style={{
                  display: 'flex', gap: '10px', alignItems: 'flex-start',
                  background: 'var(--surface-hover)', padding: '14px 16px',
                  borderRadius: '12px', border: '1px solid var(--border-color)',
                  opacity: rule.active === false ? 0.6 : 1,
                  transition: 'opacity 0.2s'
                }}
              >
                {/* Вкл/Выкл переключатель */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', marginTop: '22px', flexShrink: 0 }}>
                  <input
                    type="checkbox"
                    checked={rule.active !== false}
                    onChange={e => onUpdateRule(rule.id, 'active', e.target.checked)}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                    title={rule.active !== false ? 'Бонус активен' : 'Бонус отключен'}
                  />
                  <span style={{ fontSize: '10px', color: 'var(--text-tertiary)' }}>
                    {rule.active !== false ? 'Вкл' : 'Выкл'}
                  </span>
                </div>

                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <div className="input-group" style={{ flex: 1.5, marginBottom: 0, minWidth: '130px' }}>
                      <label>Название</label>
                      <input
                        className="input"
                        placeholder="Например: План по приемке"
                        value={rule.name}
                        onChange={e => onUpdateRule(rule.id, 'name', e.target.value)}
                      />
                    </div>
                    <div className="input-group" style={{ flex: 1.2, marginBottom: 0, minWidth: '120px' }}>
                      <label>Метрика</label>
                      <CustomSelect
                        value={rule.metric || 'accepted'}
                        onChange={val => onUpdateRule(rule.id, 'metric', val)}
                        options={[
                          { value: 'accepted', label: 'Принято (шт.)' },
                          { value: 'issued', label: 'Выдано (шт.)' },
                          { value: 'returns', label: 'Возвраты (шт.)' },
                          { value: 'hours', label: 'Часы работы (ч.)' },
                        ]}
                      />
                    </div>
                    <div className="input-group" style={{ flex: 0.8, marginBottom: 0, minWidth: '90px' }}>
                      <label>Порог (&gt;=)</label>
                      <input
                        className="input"
                        type="number"
                        placeholder="1000"
                        value={rule.threshold}
                        onChange={e => onUpdateRule(rule.id, 'threshold', e.target.value === '' ? '' : Number(e.target.value))}
                      />
                    </div>
                    <div className="input-group" style={{ flex: 0.8, marginBottom: 0, minWidth: '90px' }}>
                      <label>Премия (₽)</label>
                      <input
                        className="input"
                        type="number"
                        placeholder="1000"
                        value={rule.amount}
                        onChange={e => onUpdateRule(rule.id, 'amount', e.target.value === '' ? '' : Number(e.target.value))}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignSelf: 'flex-end', flexShrink: 0 }}>
                  <button
                    type="button"
                    className="btn btn-ghost"
                    style={{
                      color: 'var(--danger)', height: '32px', fontSize: '11px',
                      padding: '0 8px',
                    }}
                    onClick={() => onRemoveRule(rule.id)}
                  >
                    Удалить
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => onAddRule('volume_bonus')}
          style={{
            alignSelf: 'flex-start',
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '10px 18px', borderRadius: '10px',
            fontSize: '13px', fontWeight: 600,
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Добавить бонус за объем
        </button>
      </div>

    </div>
  )
}
